<ng-container>
  <section class="header-dialog-title">
    <span class="title">
      <h1 mat-dialog-title>{{ data.title | translate }}</h1>
    </span>
    <span class="close-btn" (click)="onStay()">&times;</span>
  </section>
  <section class="body-dialog-content">
    <div mat-dialog-content>
      <p>{{ data.message | translate:{count:countNumber()} }}</p>
    </div>
  </section>
  <section class="footer-dialog-button">
    <mat-dialog-actions align="end">
      <button matButton mat-dialog-close (click)="onLogout()">
        {{ data.cancelButtonText | translate }}
      </button>
      <button mat-raised-button color="primary" class="raised-btn" (click)="onStay()">
        {{ data.confirmButtonText | translate }}
      </button>
    </mat-dialog-actions>
  </section>
</ng-container>